<template>
  <div class="webphone-aside overflow-y-hidden">
    <web-phone-nav />

    <div class="webphone-aside__content">
      <component
        :is="currentComponent"
        size="lg"
      />
      <div
        v-if="$vuetify.display.xs"
        class="tab-bar-margin"
      />
    </div>
  </div>
</template>

<script>
  import { BvDialPad } from '@bv/components';

  import CallLog from './CallLogs/CallLog.vue';
  import ContactsSidebar from './Contacts/ContactsSidebar.vue';
  import WebPhoneNav from './WebPhoneNav/WebPhoneNav.vue';

  export default {
    name: 'WebPhoneSidebar',
    components: {
      WebPhoneNav,
      BvDialPad,
      CallLog,
      ContactsSidebar,
    },
    computed: {
      currentComponent() {
        switch (this.$route.name) {
          case 'dial':
            return 'BvDialPad';

          case 'call-log':
          case 'call-log-show':
            return 'CallLog';

          case 'contacts':
          case 'contact-log-show':
          default:
            return 'ContactsSidebar';
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .webphone-aside {
    height: 100%;
    width: 380px;
    min-width: 100%;
    flex-shrink: 0;
    background: var(--shadesWhite);
    padding: 16px 12px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    &__content {
      width: 100%;
      height: calc(100% - 57px);
    }
  }
</style>
